import { Box, Typography } from '@mui/material';
import React, { useState } from 'react';

import { AI_CONSENT_STORAGE_KEY } from '../../constants';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import BBCode from '/b2b/common/components/Locale/formatters/BBCode';
import Locale from '/b2b/common/components/Locale';
import ResponsiveDialog from '/b2b/common/components/ResponsiveDialog';

// Returns whether the persisted consent flag is set, guarding against environments where
// localStorage is unavailable (private mode, etc.). Any failure is treated as "not
// consented" so the user is prompted again rather than silently let through.
const hasStoredConsent = () => {
    try {
        return window.localStorage?.getItem(AI_CONSENT_STORAGE_KEY) === 'true';
    } catch {
        return false;
    }
};

// First-time consent gate for AI Assistant.
const ConsentDialog = () => {
    const [hasConsented, setHasConsented] = useState(hasStoredConsent);

    const handleAcknowledge = () => {
        try {
            window.localStorage?.setItem(AI_CONSENT_STORAGE_KEY, 'true');
        } catch {
            // If persistence fails the dialog reappears next load.
        }
        setHasConsented(true);
    };

    return (
        <ResponsiveDialog
            open={!hasConsented}
            title={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <AutoAwesomeOutlinedIcon color="primary" />
                    <Typography component="p" variant="h4">
                        <Locale path="aiAssistant.consent.title" />
                    </Typography>
                </Box>
            }
            subtitle="aiAssistant.consent.subtitle"
            onConfirm={handleAcknowledge}
            confirmText="aiAssistant.consent.acknowledge"
            maxWidth="sm"
            fullWidth
            disableEscapeKeyDown
        >
            <Typography color="text.secondary" paragraph>
                <Locale formatter={BBCode} path="aiAssistant.consent.intro" />
            </Typography>
            <Typography color="text.secondary" paragraph>
                <Locale formatter={BBCode} path="aiAssistant.consent.notLegalAdvice" />
            </Typography>
            <Typography color="text.secondary" paragraph>
                <Locale formatter={BBCode} path="aiAssistant.consent.dataUse" />
            </Typography>
            <Typography color="text.secondary" paragraph>
                <Locale formatter={BBCode} path="aiAssistant.consent.subprocessor" />
            </Typography>
            <Typography variant="caption" color="text.subtle" display="block">
                <Locale path="aiAssistant.consent.disclaimer" />
            </Typography>
        </ResponsiveDialog>
    );
};

export default ConsentDialog;
